import { useMemo, useState, useEffect } from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import { ErrorMessage } from '@calendly/form'
import { useDispatch, useSelector } from 'react-redux'

import { eventTypeSelector } from 'root-api'
import { Settings } from 'services/settings'
import RoutesHelper from 'services/asset-path'
import { useI18n } from 'locales'

import { stripeClientSecretSelector } from '../../../selectors/payment'
import { fetchClientSecret } from '../../enter_details/payment/thunks'

const Container = ({ stripeAccount, children }) => {
  const { i18n } = useI18n()
  const [error, setError] = useState(null)
  const stripePromise = useMemo(() => loadStripe(Settings.stripe.publishable_key, { stripeAccount }), [stripeAccount])
  const stripeClientSecret = useSelector(stripeClientSecretSelector)
  const dispatch = useDispatch()

  const { uuid: eventTypeUuid } = useSelector(eventTypeSelector)

  useEffect(() => {
    dispatch(fetchClientSecret(eventTypeUuid))
  }, [dispatch, eventTypeUuid])

  useEffect(() => {
    async function awaitStripePromise() {
      try {
        await stripePromise
        setError(null)
      } catch (e) {
        setError(i18n.t('errors.billing.card.payment_form_not_loaded'))
      }
    }
    awaitStripePromise()
  }, [i18n, stripePromise])

  if (error) {
    return <ErrorMessage message={error} />
  }

  const options = {
    locale: i18n.locale,
    fonts: [{ cssSrc: RoutesHelper.assetUrl('external/proxima-nova.css') }],
  }

  if (stripeClientSecret.status !== 'loaded') return <>Loading...</>
  if (stripeClientSecret.status === 'loaded') options.clientSecret = stripeClientSecret.value

  return (
    <Elements stripe={stripePromise} options={options}>
      {children}
    </Elements>
  )
}

export default Container
